import { useQuery } from '@tanstack/react-query';
import { companyApi } from '@/api/companyApi';
import { QK } from './queryKeys';
import { CompanyFilter } from '@/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUIStore } from '@/store/uiStore';
import { getApiErrorMessage } from '@/utils';

export function useCompanies(filters: CompanyFilter) {
  return useQuery({
    queryKey: QK.COMPANIES_LIST(filters),
    queryFn: () => companyApi.getList(filters),
    staleTime: 1000 * 60 * 5,
  });
}

export function useGuestCompanies(filters: CompanyFilter) {
  return useQuery({
    queryKey: ['guest', 'companies', filters],
    queryFn: () => companyApi.getGuestList(filters),
    staleTime: 1000 * 60 * 5,
  });
}

export function useCompany(id: string) {
  return useQuery({
    queryKey: QK.COMPANY(id),
    queryFn: () => companyApi.getById(id),
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
}


export function useCreateCompany() {
  const qc = useQueryClient();
  const { addToast } = useUIStore();
  return useMutation({
    mutationFn: (data: any) => companyApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['companies'] });
      addToast('success', 'Tạo công ty thành công!');
    },
    onError: (err: any) => addToast('error', getApiErrorMessage(err, 'Tạo công ty thất bại!')),
  });
}

export function useUpdateCompany() {
  const qc = useQueryClient();
  const { addToast } = useUIStore();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) => companyApi.update(id, data),
    onSuccess: (_, variables) => {
      qc.invalidateQueries({ queryKey: ['companies'] });
      qc.invalidateQueries({ queryKey: QK.COMPANY(variables.id) });
      addToast('success', 'Cập nhật công ty thành công!');
    },
    onError: (err: any) => addToast('error', getApiErrorMessage(err, 'Cập nhật công ty thất bại!')),
  });
}
